import fetch from './fetch'

const Api = {
  // 基础模块
  getInfo: params => fetch.get('/api/user', {
    params
  }),
  getPermission: params => fetch.get('/api/permission/list', {
    params
  }),
  getArea: params => fetch.get('/api/area/get', {
    params
  }),
  getParentsArea: params => fetch.get('/api/area/parents', {
    params
  }),
  getUserArea: params => fetch.get('/api/area/user', {
    params
  }),
  getAreaAll: params => fetch.get('/api/area/all', {
    params
  }),
  getUserArea2: params => fetch.get('/api/area/user2', {
    params
  }),
  getNationalArea: params => fetch.get('/api/area/listsAll', {
    params
  }), // 全国地址
  login: data => fetch.post(`/api/login?operationDevice=${data.operationDevice}`, data),
  logout: (params, data) => fetch.post(`/api/logout?selfAreaId=${params.selfAreaId}`, data),
  getSlider: () => fetch.get('/api/getSlider'),
  test: () => fetch.get('/api/hello'),
  // 资料管理
  getList: params => fetch.get('/api/information/getList', {
    params
  }),
  getDetail: params => fetch.get('/api/information/get', {
    params
  }),
  addInformation: (data, params) => fetch.post(`/api/information/add?selfAreaId=${params.selfAreaId}`, data),
  deleteInformation: params => fetch.delete2('/api/information/delete', {
    params
  }),
  // 系统设置
  getUserList: params => fetch.get('/api/user/list', {
    params
  }),
  getRoleList: params => fetch.get('/api/role/list', {
    params
  }),
  getRoleAll: params => fetch.get('/api/role/all', {
    params
  }),
  sysUserEdit: (data, params) => fetch.put(`/api/user/edit?selfAreaId=${params.selfAreaId}`, data),
  sysUserAdd: (data, params) => fetch.post(`/api/user/add?selfAreaId=${params.selfAreaId}`, data),
  roleAdd: (data, params) => fetch.post(`/api/role/add?selfAreaId=${params.selfAreaId}`, data),
  handleDelRole: (data, params) => fetch.delete(`/api/role/del?selfAreaId=${params.selfAreaId}`, data),
  roleEdit: (data, params) => fetch.post(`/api/role/edit?selfAreaId=${params.selfAreaId}`, data),
  getPermissionByRoleId: params => fetch.get('/api/role/getPermission', {
    params
  }),
  banUser: (data, params) => fetch.post(`/api/user/ban?selfAreaId=${params.selfAreaId}`, data),
  reset: (data, params) => fetch.put(`/api/user/reset?selfAreaId=${params.selfAreaId}&id=${data.id}`),
  getAuditList: params => fetch.get('/api/user/audit_list', {
    params
  }),
  audit: (data, params) => fetch.post(`/api/user/audit?selfAreaId=${params.selfAreaId}`, data),
  getDashboardTodayHistory: params => fetch.get('/api/dashboard/todayHistory', {
    params
  }),
  getBrandOnlineBike: params => fetch.get('/api/dashboard/brandOnlineBike', {
    params
  }),
  getBrandSiteBike: params => fetch.get('/api/dashboard/brandSiteBike', {
    params
  }),
  getBikeMonitor: params => fetch.get('/api/dashboard/bikeMonitor', {
    params
  }),
  getBikeNotUpload: params => fetch.get('/api/dashboard/bikeNotUpload', {
    params
  }),
  // 企业管理
  getEnterpriseList: params => fetch.get('/api/company/getEnterpriseList', {
    params
  }),
  getEnterpriseInfoById: params => fetch.get('/api/company/getEnterpriseInfoById', {
    params
  }),
  createEnterprise: (data, params) => fetch.post(`/api/company/createEnterprise?selfAreaId=${params.selfAreaId}`, data),
  saveBikeLimit: (data, params) => fetch.post(`/api/bikeLimit/save?selfAreaId=${params.selfAreaId}`, data),
  saveBikeSum: (data, selfAreaId) => fetch.post(`/api/indexPage/setAreaTotalNumber?selfAreaId=${selfAreaId}`, data),
  getBikeSum: id => fetch.get('/api/indexPage/getAreaTotalNumber', {
    params: {
      selfAreaId: id
    }
  }),
  getBikeLimit: params => fetch.get('/api/bikeLimit/isExit', {
    params
  }),
  getAreaBrandList: id => fetch.get('/api/indexPage/getAreaBrandList', {
    params: {
      selfAreaId: id
    }
  }),
  setAreaBrandNumber: (params, id) => fetch.post(`/api/indexPage/setAreaBikeNumber?selfAreaId=${id}`, params),
  deleteEnterprise: params => fetch.delete2('/api/company/deleteEnterprise', {
    params
  }),
  getDashboardInfo: params => fetch.get('/api/dashboard/brandInfo', {
    params
  }),
  getBrandChangeList: params => fetch.get('/api/uploadFile/getBrandChangeList', {
    params
  }),
  getBrandInfoById: params => fetch.get('/api/company/getBrandInfoById', {
    params
  }),
  // 设备管理
  downDeviceList: (data, params) => fetch.post(`/api/device/export/site?selfAreaId=${params.selfAreaId}`, data),
  getDeviceList: params => fetch.get('/api/device/list/get', {
    params
  }),
  getEquipmentPowerList: params => fetch.get('/api/equipment/power/list', {
    params
  }),
  deleteEquipment: (data, params) => fetch.delete(`/api/equipment/delete?selfAreaId=${params.selfAreaId}&equipmentMac=${params.equipmentMac}`, data),
  deleteDeviceSite: (data, params) => fetch.delete(`/api/device/site/delete?selfAreaId=${params.selfAreaId}`, data),
  getEquipmentPowerBetween: params => fetch.get('/api/equipment/power/between', {
    params
  }),
  getEquipmentPowerOne: params => fetch.get('/api/equipment/power/day', {
    params
  }),
  // 日常值守
  dashboardBike: params => fetch.get('/api/dashboard/bike', {
    params
  }),
  dashboard: params => fetch.get('/api/dashboard/init', {
    params
  }),
  dashboardGet: params => fetch.get('/api/dashboard/get', {
    params
  }),
  dashboardSearch: params => fetch.get('/api/dashboard/search', {
    params
  }),
  dashboardGetSite: params => fetch.get('/api/dashboard/getSite', {
    params
  }),
  getDashboardBrandBike: params => fetch.get('/api/dashboard/brandBike', {
    params
  }),
  siteReturnStatistics: params => fetch.get('/api/dashboard/siteReturnStatistics', {
    params
  }), // 站点还车折线图
  siteRentStatistics: params => fetch.get('/api/dashboard/siteRentStatistics', {
    params
  }), // 站点租车折线图
  todayHistory: params => fetch.get('/api/dashboard/todayHistory', {
    params
  }), // 今日历史消息
  siteHistory: params => fetch.get('/api/dashboard/siteHistory', {
    params
  }), // 站点历史消息
  siteBike: params => fetch.get('/api/dashboard/siteBike', {
    params
  }), // 站点车辆
  // 异常警告
  getMsgCounts: params => fetch.get('/api/abnormal/getMsgCounts', {
    params
  }),
  updateMsg: params => fetch.get('/api/abnormal/updateMsg', {
    params
  }),
  getMsg: params => fetch.get('/api/abnormal/getMsg', {
    params
  }),
  exportMsg: params => fetch.get('/api/abnormal/exportMsg', {
    params
  }),
  pwd: (data, params) => fetch.post(`/api/pwd?selfAreaId=${params.selfAreaId}`, data), // 修改密码
  checkPhone: params => fetch.get('/api/checkPhone', {
    params
  }), // 检验手机号码
  checkUsername: params => fetch.get('/api/checkUsername', {
    params
  }),
  // 运营统计
  siteRankAll: params => fetch.get('/api/statistics/siteRankAll', {
    params
  }),
  siteRankAllOut: params => fetch.downloadGet('/api/statistics/siteRankAllOut', {
    params
  }),
  sitebikeOut: params => fetch.downloadGet('/api/statistics/bikeOut', {
    params
  }),
  tidal: params => fetch.get('/api/statistics/tidal', {
    params
  }),
  reqLogOut: params => fetch.downloadGet('/api/statistics/reqLogOut', {
    params
  }),
  siteStatisticsOutput: params => fetch.downloadGet('/api/dashboard/siteStatisticsOutput', {
    params
  }),
  reqLogOutDiaodu: params => fetch.downloadGet('/api/statistics/dispatchRequestLogOut', {
    params
  }),
  brandBikeOnlinelog: params => fetch.downloadGet('/api/dashboard/brandBikeOnlineCollectOutput', {
    params
  }),
  areaVerify: params => fetch.get('/api/statistics/areaVerify', {
    params
  }),
  brandPercent: params => fetch.get('/api/statistics/brandPercent', {
    params
  }),
  brandPercentNew: params => fetch.get('/api/statistics/brandPercentNew', {
    params
  }),
  // 待处理事件
  getPendEvent: params => fetch.get('/api/statistics/pend', {
    params
  }),
  tidal2: params => fetch.get('/api/statistics/tidalRequestLog', {
    params
  }),
  brandBikeOnline: params => fetch.get('/api/dashboard/brandBikeOnlineCollect', {
    params
  }),
  siteStatistics: params => fetch.get('/api/dashboard/siteStatistics', {
    params
  }),
  getFullPileNum: params => fetch.get('/api/config/fullPileNum', {
    params
  }),
  putFullPileNum: params => fetch.put(`/api/config/fullPileNum?selfAreaId=${params.selfAreaId}&pile=${params.pile}`),
  // 觅单车管理
  fetchApiGet: (params, apiUrl) => fetch.get(apiUrl, {
    params
  }), // get请求工具方法
  fetchApiPost: (data, params, apiUrl) => fetch.post(`${apiUrl}?selfAreaId=${params.selfAreaId}`, data), // post请求工具方法
  // 区域围栏 站点围栏
  regionalArea: params => fetch.get('/api/area/', {
    params
  }),
  addRegionalArea: (data, params) => fetch.post(`/api/area/?selfAreaId=${params.selfAreaId}`, data),
  editRegionalArea: (data, params) => fetch.put2(`/api/area/?selfAreaId=${params.selfAreaId}&areaName=${data.areaName}&parentId=${data.parentId}&id=${data.id}&platformCode=${data.platformCode}&level=${data.level}&aggregation=${data.aggregation}&aggregationId=${data.aggregationId}&monitorOpen=${data.monitorOpen}`),
  getDistrictChildren: params => fetch.get(`/ws/district/v1/getchildren?key=${params.key}&id=${params.id}&max_offset=${params.max_offset}`),
  editArea: (data, params) => fetch.put2(`/api/area/?selfAreaId=${params.selfAreaId}&id=${data.id}&areaName=${data.areaName}&platformCode=${data.platformCode}&parentId=${data.parentId}&areaCode=${data.areaCode}&level=${data.level}&siteCount=${data.siteCount}&aggregation=${data.aggregation}&aggregationId=${data.aggregationId}&monitorOpen=${data.monitorOpen}&isOpen=${data.isOpen}`),
  deleteArea: (data, params) => fetch.delete2(`/api/area/${data.id}?selfAreaId=${params.selfAreaId}`),
  setRail: (data, params) => fetch.post(`/api/area/rail?selfAreaId=${params.selfAreaId}`, data),
  getRail: params => fetch.get(`/api/area/rail?selectAreaId=${params.selectAreaId}&selfAreaId=${params.selfAreaId}`),
  editRail: params => fetch.put(`/api/area/rail/${params.id}?selfAreaId=${params.selfAreaId}`, {
    gpsRail: params.gpsRail
  }),
  delRail: params => fetch.delete(`/api/area/rail/${params.id}?selfAreaId=${params.selfAreaId}`),
  setEntryRail: (data, params) => fetch.post(`/api/area/entryRail?selfAreaId=${params.selfAreaId}`, data),
  getEntryRail: params => fetch.get(`/api/area/entryRail?selectAreaId=${params.selectAreaId}&selfAreaId=${params.selfAreaId}`),
  editEntryRail: params => fetch.put2(`/api/area/entryRail/${params.id}?selfAreaId=${params.selfAreaId}&gpsRail=${params.gpsRail}`),
  // 禁停区
  getForbidList: params => fetch.get('/api/forbid/', {
    params
  }),
  addForbid: (data, params) => fetch.post(`/api/forbid/?selfAreaId=${params.selfAreaId}&areaId=${params.areaId}`, data),
  putForbid: (data, params) => fetch.put(`/api/forbid/${params.id}?selfAreaId=${params.selfAreaId}&areaId=${params.areaId}&alias=${data.alias}&fence=${data.fence}&serial=${data.serial}`, data),
  delForbid: (data, params) => fetch.delete2(`/api/forbid/${data.id}?selfAreaId=${params.selfAreaId}`),
  // 站点围栏绘制
  getRailList: params => fetch.get('/api/area/rail/', {
    params
  }),
  getSiteRailList: params => fetch.get('/api/site/rail', {
    params
  }),
  // getSiteList: params => fetch.get(`/api/site/?selfAreaId=${params.selfAreaId}&areaId=${params.areaId}`),
  getSiteList: params => fetch.get('/api/site/', {
    params
  }),
  updateSiteGps: params => fetch.put(`/api/site/gps/${params.site_id}?selfAreaId=${params.selfAreaId}&lat=${params.lat}&lon=${params.lon}`),
  putAreaCenter: params => fetch.put(`/api/site/areaCenter/${params.siteId}?selfAreaId=${params.selfAreaId}&areaId=${params.areaId}`),
  addSiteArea: (data, params) => fetch.post(`/api/site/rail?selfAreaId=${params.selfAreaId}&areaId=${params.areaId}`, data),
  setSite: (params) => fetch.post(`/api/site/?selfAreaId=${params.selfAreaId}&selectAreaId=${params.selectAreaId}&siteName=${params.siteName}&siteBikeCeiling=${params.siteBikeCeiling}&siteCeiling=${params.siteCeiling}&siteLat=${params.siteLat}&siteLon=${params.siteLon}&siteId=${params.siteId}`),
  modifySiteInfo: (params) => fetch.put(`/api/site/${params.originSiteId}?selfAreaId=${params.selfAreaId}&id=${params.originSiteId}&siteName=${params.siteName}&siteBikeCeiling=${params.siteBikeCeiling}&siteId=${params.siteId}&recycleSwitch=${params.recycleSwitch}&majorSwitch=${params.majorSwitch}&brandPutSwitch=${params.brandPutSwitch}&dispatchResponseMinute=${params.dispatchResponseMinute}&dispatchThresholdLess=${params.dispatchThresholdLess}&dispatchThresholdMore=${params.dispatchThresholdMore}&length=${params.length}`),
  multModifySite: (params) => fetch.put(`/api/site/batch?selfAreaId=${params.selfAreaId}&siteIds=${params.siteIds}&siteBikeCeiling=${params.siteBikeCeiling}&majorSwitch=${params.majorSwitch}&brandPutSwitch=${params.brandPutSwitch}&dispatchResponseMinute=${params.dispatchResponseMinute}&dispatchThresholdLess=${params.dispatchThresholdLess}&dispatchThresholdMore=${params.dispatchThresholdMore}`),
  // 满桩值设置
  getMagnify: params => fetch.get('/api/site/magnify', {
    params
  }),
  changeMagnifyOpen: params => fetch.put(`/api/site/magnify/open/${params.id}?selfAreaId=${params.selfAreaId}&openSwitch=${params.openSwitch}`),
  delMagnify: params => fetch.delete2(`/api/site/magnify/${params.id}?selfAreaId=${params.selfAreaId}`),
  checkMagnifySite: params => fetch.get('/api/site/magnify/site/clash', {
    params
  }),
  addMagnify: (params, data) => fetch.post(`/api/site/magnify?selfAreaId=${params.selfAreaId}`, data),
  editMagnify: (params, data) => fetch.put(`/api/site/magnify/${data.id}?selfAreaId=${params.selfAreaId}&siteList=${data.siteList}&alias=${data.alias}`),
  getMagnifySite: params => fetch.get('/api/site/magnify/site', {
    params
  }),
  multMatchBrand: params => fetch.put(`/api/miApp/bikeNotUploadMatch?selfAreaId=${params.selfAreaId}&bikeIds=${params.bikeIds}&brandId=${params.brandId}`),
  multMatchMac: params => fetch.put(`/api/miApp/bikeNotUploadMacMatch?selfAreaId=${params.selfAreaId}&bikeMacs=${params.bikeMacs}&brandId=${params.brandId}`),
  deleteBikeNot: (data, params) => fetch.delete(`/api/miApp/bikeNotUpload?selfAreaId=${params.selfAreaId}&bikeIds=${data.bikeIds}`),
  deleteBikeNotMac: (data, params) => fetch.delete(`/api/miApp/bikeNotUploadMac?selfAreaId=${params.selfAreaId}&bikeMacs=${data.bikeMacs}`),
  deleteRule: (id, params) => fetch.delete(`/api/miApp/brandBikeNotUploadRule/${id}?selfAreaId=${params.selfAreaId}`),
  deleteRuleMac: (id, params) => fetch.delete(`/api/miApp/brandBikeNotUploadMacRule/${id}?selfAreaId=${params.selfAreaId}`),
  editRule: (data, params) => fetch.put(`/api/miApp/brandBikeNotUploadRule/${data.id}?selfAreaId=${params.selfAreaId}&bikeIdPrefix=${data.bikeIdPrefix}&bikeIdLength=${data.bikeIdLength}&brandId=${data.brandId}`),
  editRuleMac: (data, params) => fetch.put(`/api/miApp/brandBikeNotUploadMacRule/${data.id}?selfAreaId=${params.selfAreaId}&namePrefix=${data.namePrefix}&nameLength=${data.nameLength}&brandId=${data.brandId}&bikeIdExtractStart=${data.bikeIdExtractStart}&bikeIdExtractLength=${data.bikeIdExtractLength}`),
  // 考核分类列表
  getCategory: (params) => fetch.get('/api/examine/category/list', {
    params
  }),
  editCategory: (params, data) => fetch.post(`/api/examine/category/upsert?selfAreaId=${params.selfAreaId}`, data),
  delCategory: (id, selfAreaId) => fetch.delete(`/api/examine/category/del/${id}?selfAreaId=${selfAreaId}`),
  getFixedRule: (selfAreaId) => fetch.get(`/api/examine/fixedRule/info?selfAreaId=${selfAreaId}`),
  saveFixedRule: (selfAreaId, data) => fetch.post(`/api/examine/fixedRule/upsert?selfAreaId=${selfAreaId}`, data),
  getTrendsRule: (params) => fetch.get('/api/examine/trendsRule/list', {
    params
  }),
  saveTrendsRule: (selfAreaId, data) => fetch.post(`/api/examine/trendsRule/upsert?selfAreaId=${selfAreaId}`, data),
  getBrandOut: (params) => fetch.get('/api/examine/brand/out', {
    params
  }),
  getRankDetail: (params) => fetch.get('/api/examine/brand/detail', {
    params
  }),
  getRankDetailList: (params) => fetch.get('/api/examine/brand/detail/list', {
    params
  }),
  // 月度排名、季度排名
  getRank: (params) => fetch.get('/api/examine/brand/sort', {
    params
  }),
  getRuleList: (params) => fetch.get('/api/examine/allRule/info', {
    params
  }),
  setFixedRuleConf: (selfAreaId, data) => fetch.post(`/api/examine/fixedRule/conf?selfAreaId=${selfAreaId}`, data),
  setTrendsRuleAssess: (selfAreaId, data) => fetch.post(`/api/examine/trendsRule/assess?selfAreaId=${selfAreaId}`, data),
  setTrendsRuleEnable: (selfAreaId, data) => fetch.post(`/api/examine/trendsRule/enable?selfAreaId=${selfAreaId}`, data),
  // 获取具体区域站点信息最大的站点编号
  getMaxSiteId: (selfAreaId, source) => fetch.put(`/api/site/getMaxSiteId?selfAreaId=${selfAreaId}&source=${source}`),
  // 系统考核导出
  exportSysExamineList: (selfAreaId, data) => fetch.post(`/api/examine/exportSysExamineList?selfAreaId=${selfAreaId}`, data),
  // 企业站点同步日志分页查询
  getSyncSiteLogList: params => fetch.get('/api/company/getSyncSiteLogList', {
    params
  }),
  // 站点申请审核导出
  exportCheckList: (selfAreaId, data) => fetch.post(`/api/miApp/exportCheckList?selfAreaId=${selfAreaId}`, data),
  // 站点申请画线导出
  exportLineList: (selfAreaId, data) => fetch.post(`/api/miApp/exportLineList?selfAreaId=${selfAreaId}`, data),
  // 站点申请安装导出
  exportInstallList: (selfAreaId, data) => fetch.post(`/api/miApp/exportInstallList?selfAreaId=${selfAreaId}`, data),
  // 站点申请已拒绝导出
  exportRejectList: (selfAreaId, data) => fetch.post(`/api/miApp/exportRejectList?selfAreaId=${selfAreaId}`, data),
  // 站点申请不可画线导出
  exportNoLineList: (selfAreaId, data) => fetch.post(`/api/miApp/exportNoLineList?selfAreaId=${selfAreaId}`, data),
  // 账号管理审核列表角色查询
  getAuditRoleAll: params => fetch.get('/api/role/auditRoleAll', {
    params
  }),
  // 添加账号查询所有角色
  getAddRoleAll: params => fetch.get('/api/role/addRoleAll', {
    params
  }),
  // 车位系数设置
  getFactor: (selfAreaId) => fetch.get(`/api/site/length_factor?selfAreaId=${selfAreaId}`),
  // 获取站点长度系数
  updateFactor: (selfAreaId, data) => fetch.put(`/api/site/length_factor?selfAreaId=${selfAreaId}&data=${data}`),
  // 汇总区域品牌信息
  areaBrandDetails: params => fetch.get('/api/statistics/areaBrandDetails', {
    params
  }),
  delExamine: (id, selfAreaId) => fetch.delete(`/api/examine/sortContent/del/${id}?selfAreaId=${selfAreaId}`),
  // 新增和修改考勤站点
  saveClockSiteInfo: (selfAreaId, data) => fetch.post(`/api/clock/saveClockSiteInfo?selfAreaId=${selfAreaId}`, data),
  // 根据Id删除考勤站点
  delClockSiteById: (selfAreaId, data) => fetch.post(`/api/clock/delClockSiteById?selfAreaId=${selfAreaId}&id=${data.id}`),
  // 获取考勤统计-月份用户考勤打卡数据明细
  getUserClockRecordList: params => fetch.get('/api/clockRecord/getUserClockRecordList', {
    params
  }),
  // 查询考勤打卡人员设置
  getClockConfigList: (selfAreaId) => fetch.get(`/api/clockRecord/getClockConfigList?selfAreaId=${selfAreaId}`),
  // 保存考勤打卡人员设置
  saveClockConfigInfo: (selfAreaId, data) => fetch.post(`/api/clockRecord/saveClockConfigInfo?selfAreaId=${selfAreaId}`, data),
  // 考勤打卡-日统计详细信息
  getClockStatisticsDayList: params => fetch.get('/api/clockRecord/getClockStatisticsDayList', {
    params
  }),
  // 企业管理—调度信息分页查询
  getDispatchSyncList: params => fetch.get('/api/company/getDispatchSyncList', {
    params
  }),
  // 企业管理—调度信息导出
  exportDispatchSync: params => fetch.get('/api/company/exportDispatchSync', {
    params
  }),
  // 企业管理—租还信息分页查询
  getRequestSyncList: params => fetch.get('/api/company/getRequestSyncList', {
    params
  }),
  // 企业管理—租车信息导出
  exportRequestSync: params => fetch.get('/api/company/exportRequestSync', {
    params
  }),
  // 企业管理—车辆信息分页查询
  getBikeSyncList: params => fetch.get('/api/company/getBikeSyncList', {
    params
  }),
  // 企业管理—车辆信息导出
  exportBikeSync: params => fetch.get('/api/company/exportBikeSync', {
    params
  }),
  // 扫一扫巡查统计数据查询
  getSumMiInspectionRecordsData: params => fetch.get('/api/miApp/getSumMiInspectionRecordsData', {
    params
  }),
  // 扫一扫巡查统计数据导出
  exportInspectionStatistics: params => fetch.get('/api/miApp/exportInspectionStatistics', {
    params
  }),
  // 扫一扫巡查日志数据导出
  exportInspectionLogStatistics: params => fetch.get('/api/miApp/exportInspectionLogStatistics', {
    params
  }),
  // 获取站外还车扣费数据
  getBikeOutSideFeeList: params => fetch.get('/api/bikeOutSiteFee/getFeeList', {
    params
  }),
  // 获取站外还车用户扣费详情
  getFeeUserDetails: params => fetch.get('/api/bikeOutSiteFee/getFeeUserDetails', {
    params
  }),
  // 导出站外还车用户扣费数据
  exportBikeOutSideFeeList: (selfAreaId, data) => fetch.post(`/api/bikeOutSiteFee/exportBikeOutSideFeeList?selfAreaId=${selfAreaId}`, data),
  // 企业管理—骑行订单信息分页查询
  getBikeRideOrderList: params => fetch.get('/api/company/getBikeRideOrderList', {
    params
  }),
  // 企业管理—骑行订单信息-详情查询
  getBikeRideOrderDetail: params => fetch.get('/api/company/getBikeRideOrderDetail', {
    params
  }),
  // 企业管理—骑行订单信息-详情用户行程轨迹查询
  getBikeRideOrderTrack: params => fetch.get('/api/company/getBikeRideOrderTrack', {
    params
  }),
  // 企业管理—骑行订单信息-导出
  exportBikeRideOrder: params => fetch.get('/api/company/exportBikeRideOrder', {
    params
  }),
  // 新增/编辑第三方数据授权账号
  saveThirdPartyAuthUser: (selfAreaId, data) => fetch.post(`/api/thirdPartyAuth/saveThirdPartyAuthUser?selfAreaId=${selfAreaId}`, data),
  // 查询第三方数据授权账号数据
  getThirdPartyAuthList: params => fetch.get('/api/thirdPartyAuth/getThirdPartyAuthList', {
    params
  }),
  // 第三方数据授权账号-获取区县父子集
  getCityAreaByChild: params => fetch.get(`/api/area/getCityAreaByChild?selfAreaId=${params.selfAreaId}`),
  // 第三方数据授权账号-校验手机号码
  checkAuthPhone: params => fetch.get('/api/thirdPartyAuth/checkAuthPhone', {
    params
  }),
  // 获取区域站点代码编号数
  getAreaPlatformCodeByCount: params => fetch.get('/api/area/getAreaPlatformCodeByCount', {
    params
  }),
  // 根据用户编号查询用户登录登出日志数据
  getLoginLogListByUserId: params => fetch.get('/api/getLoginLogListByUserId', {
    params
  }),
  // 首次登录需修改密码
  updateFirstLoginPwd: (data, params) => fetch.post(`/api/updateFirstLoginPwd?selfAreaId=${params.selfAreaId}`, data),
  // 删除公告通知
  deleteNotice: (id, selfAreaId) => fetch.post(`/api/miApp/deleteNotice?selfAreaId=${selfAreaId}&id=${id}`),
  // 获取用户骑行轨迹超速告警消息
  getOverSpeedAlarmList: params => fetch.get('/api/abnormal/getOverSpeedAlarmList', {
    params
  }),
  // 导出用户骑行轨迹超速告警消息
  exportOverSpeedAlarm: params => fetch.get('/api/abnormal/exportOverSpeedAlarm', {
    params
  }),
  // 设置用户骑行超速阈值
  setRideSpeedLimitConfig: (selfAreaId, data) => fetch.post(`/api/abnormal/setRideSpeedLimitConfig?selfAreaId=${selfAreaId}`, data),
  // 查询设置用户骑行超速阈值
  getRideSpeedLimitConfig: (selfAreaId) => fetch.get(`/api/abnormal/getRideSpeedLimitConfig?selfAreaId=${selfAreaId}`),
  // 新增/编辑网关设备信息
  saveGatewayEquipment: (selfAreaId, data) => fetch.post(`/api/gateway/saveGatewayEquipment?selfAreaId=${selfAreaId}`, data),
  // 查询网关设备信息
  getGatewayEquipment: params => fetch.get('/api/gateway/getGatewayEquipment', {
    params
  }),
  delGatewayEquipment: (selfAreaId, data) => fetch.post(`/api/gateway/delGatewayEquipment?selfAreaId=${selfAreaId}&gatewayId=${data.id}`)
}

export default Api
